import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import ServiceBanner from '../../components/ServiceBanner/ServiceBanner';
import OfferSection from './sections/OfferSection/OfferSection';
import ExpertReverse from '../About/sections/ExpertReverse/ExpertReverse';
import {Helmet} from 'react-helmet-async';
const samsungPhoto =  require('../../assets/images/experts/samsung.jpg');

export const Services = () => {
    return (
        <>
            <Helmet>
                                        <title>Złota Centrum Zdrowia | Oferta</title>
                                        <meta
                                          name="description"
                                          content="Nasze Centrum Zdrowia to nowoczesna placówka, która łączy profesjonalizm, doświadczenie oraz indywidualne podejście do każdego pacjenta."
                                        />
                                        {/* Open Graph / Facebook */}
                                        <meta property="og:type" content="website" />
                                        <meta property="og:url" content={window.location.href} />
                                        <meta property="og:title" content="Złota Centrum Zdrowia | Oferta" />
                                        <meta
                                          property="og:description"
                                          content="Nasze Centrum Zdrowia to nowoczesna placówka, która łączy profesjonalizm, doświadczenie oraz indywidualne podejście do każdego pacjenta."
                                        />
                                
                                        {/* Twitter */}
                                        <meta property="twitter:card" content="summary" />
                                        <meta property="twitter:url" content={window.location.href} />
                                        <meta property="twitter:title" content="Złota Centrum Zdrowia | Oferta" />
                                        <meta
                                          property="twitter:description"
                                          content="Nasze Centrum Zdrowia to nowoczesna placówka, która łączy profesjonalizm, doświadczenie oraz indywidualne podejście do każdego pacjenta."
                                        />
                                      </Helmet>
            <Navbar />
            <ServiceBanner title="Oferta" />
            <OfferSection />
            <ExpertReverse
                 title="Aparat USG klasy premium Samsung V8"
                description='W naszym Centrum wykorzystujemy aparatu USG klasy premium Samsung V8, który umożliwia przeprowadzanie szczegółowych badań diagnostycznych. Pozwala on również na wykonywanie biopsji cienkoigłowych pod kontrolą USG zwiększającym tym samym dokładność tej procedury przy użyciu m.in. funkcji Needle Mate, która pomaga lokalizować igłę, a także daje możliwość wdrażania terapii leczniczych takich jak precyzyjna iniekcja leku czy osocza bogatoplytkowego do stawów. Dzięki zaawansowanej technologii zapewniamy naszym pacjentom najwyższy standard diagnostyki obrazowej oraz małoinwazyjnych procedur leczniczych. Nasz aparat USG jest wyposażony ponadto w innowacyjną funkcję MV Flow, co istotnie zwiększa dokładność diagnostyki dzięki wizualizacji powolnego przepływu w strukturach mikronaczyniowych. Zapewnia szczegółowy obraz przepływu przy zwiększonej rozdzielczości przestrzennej, co bywa niezbędne do oceny np. patologicznych węzłów chłonnych, guzków czy też zdiagnozowanie toczącego się procesu zapalnego.'
                 photo={samsungPhoto}
                />
            <Footer />
        </>
    );
};